module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.item.id) ? _c('router-view', {
    attrs: {
      "item": _vm.item,
      "item_saved": _vm.item_saved
    },
    on: {
      "update": _vm.update
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e2d07d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/lead_masks/LeadMaskUpdate.vue
// module id = 1848
// module chunks = 0